export interface NavItem {
  label: string;
  href: string;
  highlight?: boolean;
}

export const mainNavigation: NavItem[] = [
  { label: 'Propiedades', href: '/propiedades' },
  { label: 'Venta', href: '/propiedades/venta' },
  { label: 'Alquiler', href: '/propiedades/alquiler' },
  { label: 'Proyectos', href: '/proyectos' },
  { label: 'Servicios', href: '/servicios' },
  { label: 'Vende o alquila', href: '/vende-o-alquila' },
  { label: 'Nosotros', href: '/nosotros' },
  { label: 'Contacto', href: '/contacto' },
];

export const footerNavigation = {
  properties: [
    { label: 'Todas las propiedades', href: '/propiedades' },
    { label: 'En venta', href: '/propiedades/venta' },
    { label: 'En alquiler', href: '/propiedades/alquiler' },
    { label: 'Proyectos', href: '/proyectos' },
    { label: 'Zonas', href: '/zonas' },
  ],
  services: [
    { label: 'Servicios inmobiliarios', href: '/servicios' },
    { label: 'Vende o alquila', href: '/vende-o-alquila' },
    { label: 'Asesoría legal inmobiliaria', href: '/asesoria-legal-inmobiliaria' },
    { label: 'Guías', href: '/guias' },
    { label: 'Preguntas frecuentes', href: '/preguntas-frecuentes' },
  ],
  company: [
    { label: 'Nosotros', href: '/nosotros' },
    { label: 'Equipo', href: '/equipo' },
    { label: 'Contacto', href: '/contacto' },
  ],
  legal: [
    { label: 'Privacidad', href: '/privacidad' },
    { label: 'Términos', href: '/terminos' },
    { label: 'Cookies', href: '/cookies' },
  ],
};
